<div class="flex flex-row justify-center">
  <h4 class="text-lg font-bold">
    {{ '#PASSWORD.COMPONENTS.USER_FORM.TITLE' | translate }}
  </h4>
</div>
<div class="soft-title light mt-4">
  {{ '#PASSWORD.COMPONENTS.USER_FORM.STEP1' | translate }}
</div>
<soft-ds-separator class="my-2" />

<form [formGroup]="form" (ngSubmit)="submit(form.value)">
  <div class="flex flex-col mt-4">
    <label for="password-user-form-username" class="soft-label top required">
      {{ '#PASSWORD.COMPONENTS.USER_FORM.USERNAME' | translate }}
    </label>
    <soft-input
      formControlName="username"
      id="password-user-form-username"
      autocomplete="username"
    ></soft-input>
    @if (form.controls['username'].touched) {
      <soft-validation-container
        [validation]="form | validationMessage: 'username'"
        class="soft-property-validation"
      ></soft-validation-container>
    }
  </div>
  <div class="flex flex-col mt-4">
    <label for="password-user-form-email" class="soft-label top required">
      {{ '#PASSWORD.COMPONENTS.USER_FORM.EMAIL' | translate }}
    </label>
    <soft-input
      formControlName="email"
      id="password-user-form-email"
      autocomplete="email"
    ></soft-input>
    @if (form.controls['email'].touched) {
      <soft-validation-container
        [validation]="form | validationMessage: 'email'"
        class="soft-property-validation"
      ></soft-validation-container>
    }
  </div>
  <div class="xs color light mt-2">
    {{ '#PASSWORD.COMPONENTS.USER_FORM.INFO' | translate }}
  </div>
  <div class="flex flex-row justify-center mt-3">
    <input
      type="submit"
      value="{{ '#PASSWORD.COMPONENTS.USER_FORM.SUBMIT' | translate }}"
      />
  </div>
</form>
